import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from '@material-ui/core/Grid';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbThinIntroBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`thin-intro ${props.attributes.className ? props.attributes.className : ''} ${classes.thinIntro} ${classes.thinIntroTheme}`}>
        <Grid container spacing={3} direction="row" justify="center" alignItems="center">
            <Grid item xs={12} md={8} lg={7} >
                {blocks[0]}
                {blocks[1]}
                {props.attributes.hasButton &&
                    blocks[2]
                }
            </Grid>
        </Grid>
    </div>
};

export const CgbThinIntroBlockFragment = graphql`
  fragment CgbThinIntroBlock on WpBlock {
    ... on WpCgbThinIntroBlock {
        name
        attributes {
            className
            hasButton
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbThinIntroBlockPreview = `
    ... on CgbThinIntroBlock {
        name
        attributes {
            className
            hasButton
        }
    }
`;